import { TLF_VIEW_MODES } from "aic/utility/interface"; // Needs to be imported from aic to avoid circular dependency with itself
import { SearchableEditorBlocks } from "functions/api/enums";
import { TlfContextProps } from "./interface";

export const tlfInitialState: TlfContextProps = {
  applyDelayedHierarchyUpdatesTrigger: 0,
  changed: false,
  activeVariantPatchName: null,
  activeVariantPatchInvalidOps: [],
  appliedVariantPatches: [],
  commentPanelStatus: {
    highlightCommentId: "",
    activeRelatedTo: "",
    showComments: false,
    commentFilter: "all",
  },
  delayedHierarchyUpdates: false,
  discardDelayedHierarchyUpdatesTrigger: 0,
  editorBlocksSearchPanelStatus: {
    showSearchPanel: false,
    searchText: "",
    blocksToSearch: Object.values(SearchableEditorBlocks),
  },
  forcePushToParent: false,
  isSubscribed: false,
  ixSaveVersion: -1,
  isTlfNew: false,
  ixTlfDataVersion: -1,
  masterTlfData: null,
  readOnly: false,
  receivedMessages: [],
  requestStatus: { requesting: false, error: false },
  showModalWindow: "",
  showCreateVariantPatchWindow: false,
  showTrafficLights: true,
  tlfData: null,
  tlfDataVersions: [],
  variantPatchSelectionVersions: [],
  tlfViewMode: TLF_VIEW_MODES[0],
  variantCreationView: false,
};
